import { shopApi } from "../api";
import { IOrder } from "../../Utils/types";
import { ThunkAction } from "redux-thunk";
import { AppState, AppActions } from "../Store/store";
import { setPagination } from "./paginationReducer";

interface IOrdersState {
  orders: [],
  currentOrder: IOrder,
  currentOrderStatus: 'loading' | 'loaded' | 'valid' | 'invalid'
}
const ordersState: IOrdersState = {
  orders: [],
  currentOrder: {
    id: 0,
    userId: 0,
    price: 0,
    products: [],
    status: 0,
    address: '',
    date: 0
  },
  currentOrderStatus: 'loading'
}

// Action types
export const SET_CURRENT_ORDER = 'orders/SET_CURRENT_ORDER';
export const SET_ORDERS = 'orders/SET_ORDERS';
export const REMOVE_ORDER = 'orders/REMOVE_ORDER';
export const SET_CURRENT_ORDER_STATUS = 'orders/SET_CURRENT_ORDER_STATUS';
export const SET_ORDER_STATUS = 'orders/SET_ORDER_STATUS';

// Selectors
export const ordersSelector = (state: any) => state.orders.orders;
export const currentOrderSelector = (state: any) => state.orders.currentOrder;
export const currentOrderStatusSelector = (state: any) => state.orders.currentOrderStatus;

// Reducer
export function ordersReducer(state: IOrdersState = ordersState, action: any) {
  switch (action.type) {
    case SET_ORDERS: {
      return {
        ...state,
        orders: action.payload.orders
      }
    }

    case SET_CURRENT_ORDER: {
      return {
        ...state,
        currentOrder: action.payload
      }
    }

    case SET_ORDER_STATUS: {
      return {
        ...state,
        currentOrder: {
          ...state.currentOrder,
          status: action.payload
        }
      }
    }

    case SET_CURRENT_ORDER_STATUS: {
      return {
        ...state,
        currentOrderStatus: action.payload
      }
    }

    case REMOVE_ORDER: {
      const newOrders = [...state.orders];
      const id = newOrders.findIndex((item: any) => {
        return item.id = action.payload;
      });
      newOrders.splice(id);
      return {
        ...state,
        orders: newOrders
      }
    }

    default: {
      return state;
    }
  }
}

// Actions
interface GetOrdersType {
  type: typeof SET_ORDERS,
  payload: []
}
export function getOrders(page: number, pageSize: number): ThunkAction<Promise<void>, AppState, unknown, AppActions> {
  return async (dispatch: any) => {
    const orders = await shopApi.getAllOrders(page, pageSize);
    dispatch({
      type: SET_ORDERS,
      payload: orders
    });

    dispatch(setPagination(orders.page, orders.elsePages));
  }
}

interface GetCurrentOrderType {
  type: typeof SET_CURRENT_ORDER,
  payload: IOrder
}
export function getCurrentOrder(id: number): ThunkAction<Promise<void>, AppState, unknown, AppActions> {
  return async (dispatch: any) => {
    dispatch(setCurrentOrderStatus('loading'));
    const order = await shopApi.getOrder(id);
    dispatch({
      type: SET_CURRENT_ORDER,
      payload: order
    });
    dispatch(setCurrentOrderStatus('loaded'));
  }
}

interface SetCurrentOrderStatusType {
  type: typeof SET_CURRENT_ORDER_STATUS,
  payload: string
}
export function setCurrentOrderStatus(payload: string): SetCurrentOrderStatusType {
  return {
    type: SET_CURRENT_ORDER_STATUS,
    payload
  }
}

interface RemoveOrderType {
  type: typeof REMOVE_ORDER,
  payload: number
}
export function removeOrder(id: number): ThunkAction<Promise<void>, AppState, unknown, AppActions> {
  return async (dispatch: any) => {
    await shopApi.removeOrder(id);
    dispatch({
      type: REMOVE_ORDER,
      payload: id
    });
  }
}

export function changeStatus(id: number, status: number): ThunkAction<Promise<void>, AppState, unknown, AppActions> {
  return async (dispatch: any) => {
    dispatch(setCurrentOrderStatus('loading'));
    const response = await shopApi.changeOrderStatus(id, status);
    dispatch({
      type: SET_CURRENT_ORDER_STATUS,
      payload: response.valid ? 'valid' : 'invalid'
    });
  }
}

export type OrdersActions =
  RemoveOrderType
  | SetCurrentOrderStatusType
  | GetOrdersType
  | GetCurrentOrderType;